import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayIncludes',
})
export class ArrayIncludesPipe implements PipeTransform {
    transform(
        array?: any[] | null,
        valueOrValues?: any | any[],
        property?: string,
    ): boolean {
        if (!array) {
            return false;
        }

        const valuesArray = Array.isArray(valueOrValues)
            ? valueOrValues
            : [valueOrValues];

        if (property) {
            return valuesArray.some((value) => {
                const valueProperty = this.getNestedValue(value, property);
                if (valueProperty === undefined) {
                    return false;
                }

                return array.some((item) => {
                    const itemProperty = this.getNestedValue(item, property);
                    return itemProperty === valueProperty;
                });
            });
        }

        return valuesArray.some((value) => array.includes(value));
    }

    private getNestedValue(obj: any, path: string): any {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }
}
